import { render } from "./CustomTakePhotoCamera.vue?vue&type=template&id=422e0a92&scoped=true"
import script from "./CustomTakePhotoCamera.vue?vue&type=script&lang=ts"
export * from "./CustomTakePhotoCamera.vue?vue&type=script&lang=ts"

import "./CustomTakePhotoCamera.vue?vue&type=style&index=0&id=422e0a92&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-422e0a92"

export default script